// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__8Fect","imageWrapper":"styles_imageWrapper__4jXg6","icon":"styles_icon__puXDN","title":"styles_title__4wYz_"};
module.exports.__checksum = "1994bf6dec7e"
